import React, { lazy } from 'react';
import IconDiagnose from '@/assets/images/menu/icon-diagnose.react.svg?react';
import { AuthNodes } from '@/config/app/auth';
import { getProductId } from '@/infrastructure/product-info';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { getGUID } from '@/presentation/pages/diagnose/log/utils';
import { IRouteConfig } from '../types';

const TENCENT_VIDEO_APPIDS = ['d591c6d8f7', '0cf38b5050'];

export const diagnoseRoutes = (isAdmin: boolean, diagnoseGuidMappingField?: string | null): IRouteConfig[] => {
  const appId = getProductId();
  const isTencentVideo = TENCENT_VIDEO_APPIDS.includes(appId);

  return [
    {
      path: '/diagnose',
      name: '日志',
      icon: <MenuIcon icon={IconDiagnose} fontSize={16} />,
      excludePlatforms: [
        CapitalPlatform.Hippy,
        CapitalPlatform.Kuikly,
        CapitalPlatform.MiniProgram,
        CapitalPlatform.Flutter,
        CapitalPlatform.Electron,
        CapitalPlatform.ReactNative,
      ],
      disabledByFree: true,
      sort: 85,
      authName: AuthNodes.Log,
      routes: [
        {
          path: '/diagnose/command_delivery/list',
          name: '日志查询',
          component: lazy(() => import('@/presentation/pages/diagnose/log')),
        },
        {
          path: '/diagnose/command_delivery/create',
          name: '新建查询任务',
          component: lazy(() => import('@/presentation/pages/diagnose/log/create')),
          hideInMenu: true,
        },
        {
          path: '/diagnose/colouration/list',
          name: `${getGUID(isAdmin, diagnoseGuidMappingField)?.name || '设备'}染色`,
          component: lazy(() => import('@/presentation/pages/diagnose/colouration')),
        },
        {
          path: '/diagnose/log/decode',
          name: '日志解码',
          component: lazy(() => import('@/presentation/pages/diagnose/decode')),
        },
        {
          path: '/diagnose/account/list',
          name: '账号查询',
          component: lazy(() => import('@/presentation/pages/diagnose/account/list')),
          hideInMenu: !isTencentVideo,
        },
        {
          path: '/diagnose/command_delivery/detail',
          name: '日志查询任务',
          component: lazy(() => import('@/presentation/pages/diagnose/log/detail')),
          hideInMenu: true,
        },
        {
          path: '/diagnose/colouration/details',
          name: '查看染色详情',
          component: lazy(() => import('@/presentation/pages/diagnose/colouration/details')),
          hideInMenu: true,
          whitelisted: true,
        },
        {
          path: '/diagnose/command_delivery/tags',
          name: '上报标签管理',
          component: lazy(() => import('@/presentation/pages/diagnose/tags')),
          hideInMenu: true,
          whitelisted: true,
        },
      ],
    },
  ];
};

export default diagnoseRoutes;
